import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/api';
import Header from "../components/Header";
import { useOutletContext } from "react-router-dom";
import LeftSidebar from '../components/sidebar';
const airportTimezones = {
  ATL: "ET",
  PNS: "CT",
  LIT: "CT",
  MOB: "CT",
  MDW: "CT",
};
const RotationDetail = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { routeLoading } = useOutletContext();

  useEffect(() => {
    const fetchEventDetail = async () => {
      setLoading(true);
      setError('');
      try {
        if (!eventId) {
          setError('Event ID is missing');
          return;
        }
        const res = await api.get(`/event/${eventId}`);
        if (res.data) {
          setEvent(res.data);
        } else {
          setError('No event data received');
        }
      } catch (err) {
        console.error('Failed to fetch event detail:', err);
        console.error('Error response:', err.response?.data);
        const errorMsg = err.response?.data?.error || err.message || 'Failed to load rotation details';
        setError(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventDetail();
    }
  }, [eventId]);
const getTimezoneLabel = (timezone) => {
  if (!timezone) return "--";

  if (timezone.includes("New_York")) return "ET";
  if (timezone.includes("Chicago")) return "CT";
  if (timezone.includes("Denver")) return "MT";
  if (timezone.includes("Los_Angeles")) return "PT";

  return "--";
};
  const formatDateTime = (datetime, timezone) => {
  if (!datetime) return "N/A";

  try {
    return new Date(datetime).toLocaleString("en-US", {
      timeZone: timezone || "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).replace(",", "");
  } catch (error) {
    return datetime;
  }
};

  const formatDate = (datetime) => {
    if (!datetime) return 'N/A';
    try {
      const date = new Date(datetime);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return datetime;
    }
  };
const cleanDescription = (desc) => {
  if (!desc) return "";

  let cleaned = desc;

  // Remove DESCRIPTION: prefix
  cleaned = cleaned.replace(/DESCRIPTION:/gi, "");

  // Remove import timestamp line
  cleaned = cleaned.replace(/This data imported on.*?\)/gi, "");

  // Remove unwanted labels
  cleaned = cleaned.replace(/Pilot/gi, "");
  cleaned = cleaned.replace(/Rotation Rest/gi, "");

  // Remove extra blank lines
  cleaned = cleaned.replace(/\n\s*\n/g, "\n").trim();

  return cleaned;
};
 const calculateDutyDays = (start, end) => {
  if (!start || !end) return 0;

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    return 0;
  }

  const oneDay = 24 * 60 * 60 * 1000;

  return Math.floor((endDate - startDate) / oneDay) + 1;
};
  const extractCities = (eventData) => {
  if (!eventData?.description) return "--";

  const segments = parseFlightSegments(eventData.description);

  const airports = new Set();

  segments.forEach(day => {
    day.flights.forEach(f => {
      airports.add(f.from);
      airports.add(f.to);
    });

    if (day.layover?.location) {
      airports.add(day.layover.location);
    }
  });

  return airports.size ? [...airports].join(", ") : "--";
};
// ================= FLIGHT SEGMENT PARSER =================
const parseFlightSegments = (description = '') => {
  const lines = description.split('\n').map(l => l.trim()).filter(Boolean);

  const days = [];
  let currentDay = null;

  lines.forEach((line) => {

    // ===== REPORT LINE =====
    const rptMatch = line.match(/^Rpt-\s*(\d+)\s*(\d{2}[A-Z]{3})/);

    if (rptMatch) {
      const rawReport = rptMatch[1];
      const formattedReport =
        rawReport.length === 4
          ? `${rawReport.slice(0, 2)}:${rawReport.slice(2)}`
          : rawReport;

      const rawDay = rptMatch[2];
      const formattedDay =
        rawDay.length === 5
          ? `${rawDay.slice(0, 2)} ${rawDay.slice(2)}`
          : rawDay;

      currentDay = {
        reportTime: formattedReport,
        day: formattedDay,
        flights: [],
        layover: null,
        hotel: null,
      };

      days.push(currentDay);
      return;
    }

    // ===== FLIGHT LINE =====
    const flightMatch = line.match(
      /^(DL\d+)\s+([A-Z]{3})-([A-Z]{3})\s+(\d{2}:\d{2})-(\d{2}:\d{2})\s+(\w+)/
    );

    if (flightMatch && currentDay) {
      currentDay.flights.push({
        flightNo: flightMatch[1],
        from: flightMatch[2],
        to: flightMatch[3],
        departure: flightMatch[4],
        arrival: flightMatch[5],
        aircraft: flightMatch[6],
      });
      return;
    }

    // ===== LAYOVER =====
    const layoverMatch = line.match(/^LAYOVER\s+(\d{2}:\d{2})\/([A-Z]{3})/);

    if (layoverMatch && currentDay) {
      currentDay.layover = {
        duration: layoverMatch[1],
        location: layoverMatch[2],
      };
      return;
    }

    // ===== HOTEL =====
    const hotelMatch = line.match(/^(.+?):\s+(\d{3}-\d{3}-\d{4})/);

    if (hotelMatch && currentDay) {
      currentDay.hotel = {
        name: hotelMatch[1],
        phone: hotelMatch[2],
      };
    }

  });

  return days;
};

// ✅ THIS IS WHAT ESLINT IS COMPLAINING ABOUT
const flightSegments = event?.description
  ? parseFlightSegments(event.description)
  : [];

  if (routeLoading || loading) {
  return null; // Let AppLayout show GIF loader
}

  if (error || !event) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          {error || 'Rotation not found'}
        </div>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      </div>
    );
  }

return (
  <main className="dashboard-screen">
    <div className="container-fluid">
      <div className="row gx-5">
        <div className="col-lg-3 left-sidebar-main">
          <LeftSidebar />
        </div>
        <div className="col-lg-9">
          <Header />
          <div className="row contact-section" >
            <div className="col-sm-12">              
              <h1 className="event-detail-title">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  style={{ background: 'none', border: 'none', padding: 0, marginRight: '8px' }}
                  aria-label="Back"
                >
                  <img src="/icons/logout.svg" alt="Back" />
                </button>
                Event Details
              </h1>
                <div className="event-inner">                
                  {/* Rotation Summary Section */}
                  <div className="dash-section3 mb-5 rotation-title">                  
                      <h3 className="title-inner mb-5">Rotation Summary</h3>
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <h5 className="title-inner">{event.summary || 'Untitled Rotation'}</h5>
                          <span className="title_small">
                            Calendar: {event.calendar_name || 'Unknown Calendar'}
                          </span>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <span className="title_small">Start Date & Time</span>
                          <div className="subtitle4"> {formatDateTime(event.start, event.start_timezone)} ({event.start_timezone})</div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <span className="title_small">End Date & Time</span>
                          <div className="subtitle4">{formatDateTime(event.end, event.end_timezone)} ({event.end_timezone})</div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <span className="title_small">Cities Involved</span>
                          <div className="subtitle4">{extractCities(event)}</div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <span className="title_small">Duration (Days)</span>
                          <div className="subtitle4">
                            {calculateDutyDays(event.start, event.end)}
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <span className="title_small">Overnights</span>
                          <div className="subtitle4">
                            {flightSegments.filter(day => day.layover).length}
                          </div>
                        </div>
                      </div>

                      {event.location && (
                        <div className="row">
                          <div className="col-12 mb-3">
                            <span className="title_small">Location</span>
                            <div>{event.location}</div>
                          </div>
                        </div>
                      )}            
                  
                  </div>
   
<div className="event-inner2">

  {flightSegments.length > 0 ? (
    <>
      <h5 className="title-inner mb-4">Flight Segments</h5>

      <div className="dash-section3 mb-5 rotation-title">
        {flightSegments.map((day, dayIndex) => (
          <div key={dayIndex} className="mb-5">

            <h3 className="title-inner mb-5">
			  DAY {dayIndex + 1} – {day.day}{" "}
			  {new Date(event.start).getFullYear()}
			</h3>

            {day.reportTime && (
              <div className="mb-4 fw-bold">
                Report Time: {day.reportTime}
              </div>
            )}

            {day.flights.map((f, flightIndex) => (
              <div key={flightIndex} className="mb-5">

                <div className="row mb-4">
                  <div className="col-md-12">
                    <h5 className="title-inner">
                      {f.flightNo} — {f.from} → {f.to}
                    </h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span className="title_small">Departure:</span>
                    <div className="subtitle4">
                      {f.departure} 
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <span className="title_small">Arrival:</span>
                    <div className="subtitle4">
                      {f.arrival} 
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <span className="title_small">Aircraft:</span>
                    <div className="subtitle4">
                      {f.aircraft}
                    </div>
                  </div>
                </div>

              </div>
            ))}

            {day.layover && (
              <>
                <div className="row my-4">
                  <div className="col-md-12">
                    <h5 className="title-inner">Layover:</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span className="title_small">Location:</span>
                    <div className="subtitle4">
                      {day.layover.location}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <span className="title_small">Time:</span>
                    <div className="subtitle4">
					  {day.layover.duration} 
					</div>
                  </div>
                </div>
              </>
            )}

            {day.hotel && (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <span className="title_small">Hotel:</span>
                  <div className="subtitle4">
                    {day.hotel.name}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <span className="title_small">Hotel Phone:</span>
                  <div className="subtitle4">
                    {day.hotel.phone}
                  </div>
                </div>
              </div>
            )}

          </div>
        ))}
      </div>
    </>
  ) : (
    <>
      <h5 className="title-inner mb-4">Description</h5>

      <div className="dash-section3 mb-0">
        <div className="subtitle4" style={{ whiteSpace: "pre-line" }}>
          {cleanDescription(event.description) || "No details available."}
        </div>
      </div>
    </>
  )}

</div>

                  {/* Additional Info */}
                  <div className="dash-section3 mt-5">
                    <div className="event-additional-info">
                      <strong>Calendar:</strong> {event.calendar_name || 'Unknown'} <br />
                      <strong>Created:</strong> {formatDate(event.created_at) || 'N/A'}
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
  </main>
  );
};

export default RotationDetail;
